import { css } from 'styled-components';
import type { DefaultTheme } from './theme';

interface ThemeProps {
  theme: DefaultTheme;
}

export function responseFont(minSize?: number, size?: number, limit?: number) {
  return (props: ThemeProps) => {
    const { theme } = props;
    minSize = minSize ?? theme.font.sizeMin;
    size = size ?? theme.font.size;
    limit = limit ?? theme.pageLimit({ theme });
    const baseline = theme.breakpoints.sm.width;
    const fontMultiplier = (size - minSize) / (limit - baseline);
    const fontBaseline = minSize - fontMultiplier * baseline;

    return css`
      font-size: ${minSize}px;

      @media (min-width: ${theme.breakpoints.sm.width}px) {
        font-size: calc(${fontMultiplier} * 100vw + (${fontBaseline}px));
      }

      @media (min-width: ${limit}px) {
        font-size: ${size}px;
      }
    `;
  };
}

export function gutter(increment: number) {
  return `${increment * 8}px`;
}

export function color(name: keyof DefaultTheme['colors']) {
  return (props: any) => props.theme.colors[name];
}

export function fit() {
  return css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `;
}
